<template>
  <b-container fluid>
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            Pièce de rechange
            <div v-if="!isBusy" class="subtitle">#{{ values.name }}</div>
          </h1>
        </div>
        <div v-if="values.id" class="text-right">
          <b-button variant="outline-primary ml-10" size="lg" @click="openFormModal(values.id)">
            Modifier la fiche
            <i class="far fa-pencil fa-lg ml-10"></i>
          </b-button>
          <b-button
            variant="outline-primary ml-10"
            size="lg"
            v-if="!config.hideActionPdfButton"
            @click="$root.exportPdf(exportPdfData)"
          >
            Exporter en PDF
            <i class="far fa-file-alt fa-lg ml-10"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content divided">
            <b-row>
              <b-col>
                <dl>
                  <dt>{{ labels.brand }} :</dt>
                  <dd>{{ values.brand || "-" }}</dd>
                  <dt>{{ labels.brand_reference }} :</dt>
                  <dd>{{ values.brand_reference || "-" }}</dd>
                  <dt>{{ labels.internal_code }} :</dt>
                  <dd>{{ values.internal_code || "-" }}</dd>
                  <dt>{{ labels.supplier }} :</dt>
                  <dd>
                    <router-link
                      v-if="rawValues.supplier"
                      :to="{ name: 'CompanyDetail', params: { id: rawValues.supplier.id } }"
                      >{{ values.supplier }}</router-link
                    >
                  </dd>
                  <dt>{{ labels.unit_purchase_price }} :</dt>
                  <dd>{{ values.unit_purchase_price || "-" }}</dd>
                  <dt>{{ labels.rebilling_percentage }} :</dt>
                  <dd>{{ values.rebilling_percentage || "-" }}</dd>
                </dl>
              </b-col>
              <b-col>
                <h3>Description</h3>
                {{ values.description }}
              </b-col>
              <b-col class="d-flex flex-column">
                <h3>Stockage</h3>
                <div
                  v-if="storageLocations.length"
                  class="
                    storage_location
                    flex-grow-1
                    d-flex
                    flex-column
                    justify-content-center
                    flex-nowrap
                  "
                >
                  <ul v-if="$root.isAuthorized('storage-environment_index')">
                    <li v-for="(storageLocation, index) in storageLocations" :key="index">
                      <router-link
                        :to="{
                          name:
                            storageLocation.type == 'storage_zone'
                              ? 'StorageZoneDetail'
                              : 'StorageEnvironmentDetail',
                          params: { id: storageLocation.id },
                        }"
                        >{{ storageLocation.name }}</router-link
                      >
                    </li>
                  </ul>
                  <b-badge
                    :variant="
                      rawValues.stock_quantity <= 0
                        ? 'danger'
                        : rawValues.stock_quantity <= rawValues.minimum_stock
                        ? 'warning'
                        : 'success'
                    "
                    >{{ rawValues.stock_quantity }} en stock</b-badge
                  >
                </div>
              </b-col>
              <b-col class="d-flex flex-column barcode-col">
                <h3>Code barre</h3>
                <b-row class="flex-grow-1 flex-column barcode-wrapper justify-content">
                  <div class="text-center">
                    <div>{{ values.internal_code }}</div>
                  </div>
                  <barcode
                    class="text-center"
                    :value="values.internal_code"
                    :displayValue="false"
                    height="50"
                    >Impossible de générer le code à barres</barcode
                  >
                </b-row>
                <b-row>
                  <b-col class="text-center bottom-link">
                    <a href @click.prevent="printBarcode()">
                      Imprimer
                      <i class="fa fa-chevron-right"></i>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="ProductsItems && ProductsItems.length">
        <div class="ibox">
          <div class="ibox-title">
            <i class="far fa-wrench"></i>
            Références matériel
          </div>
          <div class="ibox-content">
            <b-table hover :fields="product_fields" :items="ProductsItems">
              <template slot="name" slot-scope="data">
                <router-link :to="{ name: 'ProductDetail', params: { id: data.item.id } }">{{
                  data.value
                }}</router-link>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm
      v-if="config.useNewModal || config.useEditModal"
      :config="config"
      :id_to_edit="id_to_edit"
    />
  </b-container>
</template>

<script>
import config from "./config";
import product_config from "@/components/Product/config";
import AdminModalForm from "@/components/Global/AdminModalForm";
import barcodeLabel from "@/mixins/barcodeLabel";

export default {
  name: "SparePartDetail",
  mixins: [barcodeLabel],
  components: {
    AdminModalForm,
  },
  data() {
    return {
      config: config,
      product_config: product_config,
      labels: {},
      product_fields: [],
      storageLocations: [],
      isBusy: false,
      id_to_edit: null,
    };
  },
  computed: {
    rawValues: function () {
      return this.$store.getters[config.storeNamespace + "/getItem"](this.$route.params.id) || {};
    },
    values: function () {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter((field) => field.inDetail == true)
      );
    },
    ProductsItems: function () {
      return this.rawValues.products
        ? this.$root.formatDatas(
            this.rawValues.products,
            this.product_config.fields.filter((field) => field.inDetail == true)
          )
        : [];
    },
    exportPdfData: function () {
      let exportPdfData = {
        title: this.config.pdf_export_title
          ? this.config.pdf_export_title(this.rawValues, this.values, this)
          : this.values[this.config.titleField],
        link: this.config.pdf_export_link
          ? this.config.pdf_export_link(this.rawValues, this.values, this)
          : null,
        infos: [],
      };

      if (this.config.pdf_export_logo) {
        exportPdfData.logo = this.config.pdf_export_logo;
      }

      if (this.config.pdf_export_extra_content_before) {
        exportPdfData.extra_content_before = this.config.pdf_export_extra_content_before(
          this.rawValues,
          this.values,
          this
        );
      }

      if (this.config.pdf_export_custom_main_content) {
        exportPdfData.custom_main_content = this.config.pdf_export_custom_main_content(
          this.rawValues,
          this.values,
          this
        );
      } else {
        this.config.fields
          .filter((field) => field.inPdfExport == true)
          .forEach((field) => {
            exportPdfData.infos.push([
              field.label + " :",
              field.type == "yesno"
                ? this.values[field.name] == true
                  ? "Oui"
                  : "Non"
                : this.values[field.name] || null,
            ]);
          });
      }

      exportPdfData.lists = [];
      if (this.lists && this.lists.length) {
        this.lists.forEach((list) => {
          let currentList = {
            label: list.label,
            infos: [this.lists_fields[list.name].map((f) => f.label)],
          };
          this.listsItems[list.name].forEach((item) => {
            let infosItem = [];
            list.fields.forEach((field) => {
              infosItem.push(item[field] || null);
            });
            currentList.infos.push(infosItem);
          });
          exportPdfData.lists.push(currentList);
        });
      }

      if (this.config.pdf_export_extra_lists) {
        exportPdfData.lists.push(
          ...this.config.pdf_export_extra_lists(this.rawValues, this.values, this)
        );
      }

      if (this.config.pdf_export_extra_content_after) {
        exportPdfData.extra_content_after = this.config.pdf_export_extra_content_after(
          this.rawValues,
          this.values,
          this
        );
      }

      return exportPdfData;
    },
  },
  mounted() {
    // Chargement des champs à afficher dans le détail depuis la config
    // Et récupération des libellés
    config.fields
      .filter((field) => field.inDetail == true)
      .forEach((field) => {
        this.labels[field.name] = field.label;
      });

    this.isBusy = true;
    this.$store
      .dispatch(config.storeNamespace + "/getItem", {
        id: this.$route.params.id,
        wait: true,
      })
      .then(() => {
        // Test si le contenu demandé est bien trouvé
        let self = this;
        if (Object.entries(this.rawValues).length <= 0) {
          this.$toastr.error(
            "La fiche demandée n'a pas été trouvée. Assure-vous que l'URL saisie soit correcte."
          );
          setTimeout(function () {
            self.$router.go(-1);
          }, 5000);
          return;
        }
        if (
          this.rawValues.storage_environment &&
          this.$root.isAuthorized("storage-environment_index")
        ) {
          this.$store.dispatch("storage_environment/getAll").then(() => {
            this.getParentLocation(this.rawValues.storage_environment);
          });
        }
        this.isBusy = false;
      });

    // Préparation des champs pour les listes des références
    let product_fields = product_config.fields
      .filter((field) => ["name", "internal_code", "equipment_group"].includes(field.name))
      .map((field) => ({
        key: field.name,
        label: field.label,
      }));
    this.product_fields = product_fields;
  },
  methods: {
    openFormModal(id) {
      this.id_to_edit = id;
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    /**
     * Fonction récursive qui remonte le chemin du lieu de stockage jusqu'au dernier parent
     * @param   {object}    item              Environnement de stockage enfant
     */
    getParentLocation(item) {
      if (item) {
        const storage_environment = {
          id: item.id,
          name: item.name,
          type: "storage_environment",
        };
        this.storageLocations.unshift(storage_environment);

        if (item.parent_storage_environment) {
          this.getParentLocation(
            this.$store.getters["storage_environment/getItem"](item.parent_storage_environment.id)
          );
        } else if (item.storage_zone) {
          const storage_zone = {
            id: item.storage_zone.id,
            name: item.storage_zone.name,
            type: "storage_zone",
          };
          this.storageLocations.unshift(storage_zone);
        }
      }
    },
    printBarcode() {
      this.printBarcodeLabel();
    },
  },
};
</script>

<style lang="scss">
.barcode-wrapper > :nth-child(1) {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/SparePart/SparePartDetail.vue